import React, { Component } from "react";

import QuestionSelectorMenu from "./QuestionSelectorMenu/QuestionSelectorMenu";

import "./styles.css";

class QuestionCreatorHeaderMenu extends Component {
  render() {
    return (
      <div className="question-creator-header">
        <div>
          <QuestionSelectorMenu
            readOnly={this.props.readOnly}
            currentTypeId={this.props.currentTypeId}
            items={this.props.itemTypes}
            typeSelector={this.props.typeChanger}
          />
        </div>
      </div>
    );
  }
}

export default QuestionCreatorHeaderMenu;
